import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { useClickOutside } from 'react-haiku';

import Show from 'components/Show';

const Menu = ({ handler: Handler, placement = 'br', options }) => {
	// Store menu's container ref
	const ref = useRef(null);

	// Store category's expanded state
	const [show, setShow] = useState(false);

	// Toggle category's expansion
	const toggle = () => setShow(p => !p);

	// Use outside handler
	useClickOutside(ref, () => setShow(false));

	// Create className based on placement
	const cls = classnames(
		'min-w-[10rem] py-2 absolute z-10 translate-y-full rounded-lg bg-white border border-neutral-100 dark:bg-neutral-800 dark:border-transparent whitespace-nowrap animate-fade-in',
		placement === 'br' && '-bottom-2 right-0',
		placement === 'bl' && '-bottom-2 left-0',
		placement === 'bc' && '-bottom-2 left-1/2 -translate-x-1/2'
	);

	// h-7 leading-7 is a fix
	// currently removed
	return (
		<div ref={ref} className="relative max-w-fit">
			<Handler onClick={toggle} />

			<Show if={show}>
				<div className={cls}>
					{options?.map(option =>
						<div key={option.text} onClick={option.onClick} className="px-3 h-8 text-sm leading-8 text-neutral-700 hover:bg-neutral-50 dark:text-neutral-100 dark:hover:bg-neutral-700 cursor-pointer transition-colors">{option.text}</div>	
					)}
				</div>
			</Show>
		</div>
	);
};

export default Menu;